import { createSlice } from '@reduxjs/toolkit';
import { fetchRoles, fetchPermissions, updateRolePermissions, createRole  } from './rolesThunk';
import { toast } from 'react-toastify';

const initialState = {
  rolesList: [],
  permissionsList: [],
  status: 'idle', // 'idle', 'loading', 'succeeded', 'failed'
  error: null,
};

const rolesSlice = createSlice({
  name: 'roles',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Gérer le chargement des rôles
      .addCase(fetchRoles.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchRoles.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.rolesList = action.payload;
      })
      .addCase(fetchRoles.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
      // Gérer le chargement des permissions
      .addCase(fetchPermissions.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchPermissions.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.permissionsList = action.payload;
      })
      .addCase(fetchPermissions.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
      // Gérer la mise à jour d'un rôle
      .addCase(updateRolePermissions.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(updateRolePermissions.fulfilled, (state, action) => {
        state.status = 'succeeded';
        toast.success('Permissions mises à jour avec succès !');
        // On met à jour la liste des rôles avec le rôle modifié
        const index = state.rolesList.findIndex(role => role.id === action.payload.id);
        if (index !== -1) {
          state.rolesList[index] = action.payload;
        }
      })
      .addCase(updateRolePermissions.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
        toast.error('Erreur lors de la mise à jour des permissions.');
      })

      .addCase(createRole.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(createRole.fulfilled, (state, action) => {
        state.status = 'succeeded';
        // On ajoute le nouveau rôle à la liste existante
        state.rolesList.push(action.payload);
        toast.success(`Le rôle "${action.payload.name}" a été créé avec succès !`);
      })
      .addCase(createRole.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
        toast.error('Erreur lors de la création du rôle.');
      });
  },
});

export default rolesSlice.reducer;